<template>
	<div>
		<FlexiblePaymentCondition
			v-if="showFlexible"
			:displayTitle="props.displayTitle"
			:prestId="props.prestId"
			:isPVFlex="props.isPVFlex === true"
			:isDisplayPlaceholders="props.isDisplayPlaceholders"
			:content="store.state.content"
			:cancellationDate="props.cancellationDate"
			:startDate="startDate" 
			:isCompactDisplay="props.isCompactDisplay"
			/>

		<FixedPaymentCondition
			v-else
			:displayTitle="props.displayTitle"
			:prestId="props.prestId"
			:isDisplayPlaceholders="props.isDisplayPlaceholders"
			:content="store.state.content" 
			:isCompactDisplay="props.isCompactDisplay"
			/>
	</div>
</template>

<script setup lang="ts">
import { defineProps, computed, ComputedRef } from "vue"

// Store
//import store from "@/vue/planning/store/store"

// Enums
import { PaymentCondition } from "@/enums/paymentCondition"

// Components
import FlexiblePaymentCondition from "./FlexiblePaymentCondition.vue"
import FixedPaymentCondition from "./FixedPaymentCondition.vue"


import { useStore } from "vuex"
const store = useStore();

// Props
interface Props {
	paymentCondition: number
	displayTitle: boolean
	cancellationDate: string
	isPVFlex?: boolean
	prestId?: string
	isDisplayPlaceholders?: boolean
	isCompactDisplay?: boolean
}

const props = defineProps<Props>()

// Computed
const startDate: ComputedRef<string> = computed(() => {
	return store.state.dates.BeginDate || ""
})

// PV availabilities always send paymentCondition=2 for both flex and nonflex;
// FLEX vs FIXE is carried by pvFlex and passed here as isPVFlex.
const showFlexible: ComputedRef<boolean> = computed(() => {
	if (typeof props.isPVFlex === "boolean") {
		return props.isPVFlex
	}
	return props.paymentCondition === PaymentCondition.FLEXIBLE
})
</script>
